import {
  getCustomerPayments,
  getOrderById,
  physicalPayment,
  getCashBox,
  adjustCashBox,
  getReceiptByNumber,
  updateReceiptByNumber,
  cancelReceiptByNumber,
  getPendingInvoices,
} from 'api/payment';
import { validateDiscount, getActiveDiscount } from 'api/customer/discount';
import { validateCustomerPayment,  } from 'api/customer/payment';
import { useSnackbar } from 'notistack';
import { useMutation, useQuery } from 'react-query';

function usePayment(success, error) {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(physicalPayment, {
    onError: (err) => {
      enqueueSnackbar(err.message, { variant: 'error' });
      error && error(err);
    },
    onSuccess: () => {
      enqueueSnackbar('پرداخت با موفقیت ثبت شد.', { variant: 'success' });
      success && success();
    },
  });
}

function useValidatePayment() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(validateCustomerPayment, {
    onError: (err) => {
      // enqueueSnackbar(err.message, { variant: 'error' })
      // error && error(err);
    },
    onSuccess: () => {
      // enqueueSnackbar('پرداخت با موفقیت ثبت شد.', { variant: 'success' })
      // success();
    },
  });
}

function useActiveDiscount(){
  return useMutation(getActiveDiscount);
}

function useValidateDiscount() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(validateDiscount, {
    onError: (err) => {
      console.log("err",err)
      enqueueSnackbar(err.message, { variant: 'error' });
      // error && error(err);
    },
    onSuccess: (data) => {
      if(data.status ==="OK")
      enqueueSnackbar('تخفیف  با موفقیت اعمال شد', { variant: 'success' });
      else
      enqueueSnackbar(data.message, { variant: 'error' });
      // success();
    },
  });
}

function useCustomerPayments(id) {
  return useQuery(['customerPayments', id], () => getCustomerPayments(id), {
    enabled: !!id,
  });
}

function useOrder(id) {
  return useQuery(['order', id], () => getOrderById(id), {
    enabled: !!id,
  });
}

function usePendingInvoices(params) {
  return useQuery(['pendingInvoices', params], () => getPendingInvoices(params), {
    keepPreviousData: true,
  });
}

function useCashBox() {
  return useQuery(['cashbox'], () => getCashBox(), {
    enabled: true,
  });
}

function useAdjustCashBox() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(adjustCashBox, {
    onError: (err) => {
      enqueueSnackbar(err?.response?.data?.message || err.message, { variant: 'error' });
    },
    onSuccess: (data, variables, context) => {
      enqueueSnackbar('تغییر صندوق ثبت شد', { variant: 'success' });
    },
  });
}

function useFindReceipt() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(getReceiptByNumber, {
    onError: (err) => {
      enqueueSnackbar(err?.response?.data?.message || err.message, { variant: 'error' });
    },
  });
}

function useUpdateReceipt() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(updateReceiptByNumber, {
    onError: (err) => {
      enqueueSnackbar(err?.response?.data?.message || err.message, { variant: 'error' });
    },
    onSuccess: () => {
      enqueueSnackbar('فاکتور به‌روزرسانی شد.', { variant: 'success' });
    },
  });
}

function useCancelReceipt() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(cancelReceiptByNumber, {
    onError: (err) => {
      enqueueSnackbar(err?.response?.data?.message || err.message, { variant: 'error' });
    },
    onSuccess: () => {
      enqueueSnackbar('فاکتور لغو شد.', { variant: 'success' });
    },
  });
}

export {
  usePayment,
  useValidatePayment,
  useCustomerPayments,
  useOrder,
  usePendingInvoices,
  useValidateDiscount,
  useActiveDiscount,
  useCashBox,
  useAdjustCashBox,
  useFindReceipt,
  useUpdateReceipt,
  useCancelReceipt,
};
